<template>
  <div class="top">
    <div class="top-inner">
      <div class="heads">
        <h1 class="title">
          <img
            src="../../../assets/images/_parts/other/logo.svg"
            alt="Find My SKINCARE"
          />
        </h1>
        <p class="subtitle">スキンケア商品検索チャート</p>
        <div class="buttonWrapper">
          <MiniButton class="guide-button" @clickButton="handleShowModal()">
            <svg
              class="guide-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 8.12 13"
              width="8.12px"
              height="13px"
            >
              <g>
                <path
                  class="cls-1"
                  d="M3.93,9.72c.54,0,.58-.3.58-.69,0-1.34.53-1.78,1.83-2.83,1.07-.89,1.78-1.48,1.78-3C8.12.55,6,0,4.21,0,.12,0,0,3.18,0,3.55s.2.66.6.66.62-.26.65-.55C1.33,2.67,1.46,1,4.19,1c2.23,0,2.7,1.18,2.7,2.17,0,1.28-.66,1.8-2,2.82A3.21,3.21,0,0,0,3.33,8.85v.29C3.33,9.53,3.52,9.72,3.93,9.72Z"
                />
                <path
                  class="cls-1"
                  d="M3.91,11.32a.84.84,0,0,0-.83.85.82.82,0,0,0,.83.83.84.84,0,0,0,.85-.83A.85.85,0,0,0,3.91,11.32Z"
                />
              </g>
            </svg>
            <span class="minibutton-text">使い方ガイド</span>
          </MiniButton>
        </div>
      </div>
      <p class="desc">
        下にスクロールすることで、様々な商品情報を一覧で見ることができます。アイテム探しにぜひご活用ください。<br />
        ※各商品カテゴリーの人気上位10位内の商品には商品画像右上に順位を表示しています。使用方法の期間は使用方法にそった使い方での目安です。
      </p>
    </div>
  </div>
</template>
<script>
import MiniButton from "../../ui/buttons/MiniButton.vue";
import { adobeClickEvent } from "../../../modules/analytics";

export default {
  name: "Top",
  methods: {
    analyze(eventId, url) {
      adobeClickEvent(eventId, url);
    },
    handleShowModal() {
      this.analyze("howtouse");
      this.$emit("showHowto");
    },
  },
  components: { MiniButton },
};
</script>
<style lang="scss" scoped>
.top {
  width: 100%;

  .top-inner {
    width: 100%;
    $sidePadding: 20px;
    max-width: 960px + $sidePadding * 2;
    margin: 0 auto;
    padding: 0 $sidePadding;
  }

  .heads {
    position: relative;
  }

  .title {
    width: 560px;
    margin: 0 auto 0;
    position: relative;
    left: -15px;
  }

  .subtitle {
    font-size: 20px;
    font-weight: 600;
    margin-top: 18px;
    letter-spacing: 6px;
    text-align: center;
  }

  .desc {
    letter-spacing: 1.3px;
    margin-top: 17px;
    text-align: center;
    letter-spacing: 1px;
  }

  .buttonWrapper {
    position: absolute;
    top: 0;
    right: 0;
  }

  .guide-button {
    width: 111px;
  }

  .guide-icon {
    width: 8px;
    height: 13px;
    margin-right: 5px;
  }

  @include media() {
    width: 100%;

    .top-inner {
      max-width: none;
    }

    .heads {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
    }

    .title {
      width: 100%;
      left: auto;
    }

    .subtitle {
      font-size: vw(16);
      margin-top: vw(8);
      letter-spacing: vw(1.6);
    }

    .buttonWrapper {
      margin-top: vw(12);
      position: relative;
      top: auto;
      right: auto;
    }

    .guide-button {
      width: vw(85);
    }

    .guide-icon {
      width: vw(6);
      height: vw(10);
      margin-right: vw(3);
    }

    .desc {
      font-size: vw(10);
      letter-spacing: initial;
      margin-top: vw(7);
      text-align: left;
      line-height: 1.6;
    }
  }
}
</style>
